module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.27028",
      "ably": "static-2.2",
      "conversations-async-data": "static-2.6997",
      "conversations-error-reporting": "static-1.8267",
      "conversations-internal-pub-sub": "static-1.15352",
      "conversations-internal-schema": "static-1.11995",
      "conversations-message-history": "static-1.10619",
      "conversations-test-sdk": "static-1.9807",
      "conversations-visitor-experience-components": "static-1.20391",
      "head-dlb": "static-1.4360",
      "hs-promise-utils": "static-1.4872",
      "hs-test-utils": "static-1.7343",
      "hubspot-dlb": "static-2.1707",
      "HubStyleTokens": "static-2.10863",
      "I18n": "static-7.1452",
      "jasmine-immutable": "static-1.2313",
      "jasmine-runner": "static-1.5770",
      "quartz": "static-1.6162",
      "react-dlb": "static-1.62",
      "react-transition-group": "static-2.8",
      "redux-thunk": "static-2.43",
      "transmute": "static-2.77",
      "urlinator": "static-1.3887",
      "viral-links-lib": "static-1.6257",
      "visitor-ui-component-library": "static-1.5509",
      "webpack-env": "static-1.54",
      "ably-hubspot-js": "static-2.3914",
      "atom": "static-1.4498",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4141",
      "conversations-infrastructure": "static-1.8290",
      "conversations-prop-types": "static-1.6780",
      "conversations-visibility-tools": "static-1.5118",
      "conversations-visitor-message-history": "static-1.19128",
      "cssUtils": "static-1.602",
      "enviro": "static-4.328",
      "flux-actions": "static-1.287",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.5499",
      "hubspot-url-utils": "static-1.3531",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "metrics-js": "static-1.9058",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.306",
      "raven": "static-3.5229",
      "react": "static-7.151",
      "react-aria": "static-1.44",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "react-rhumb": "static-1.15950",
      "react-select-plus": "static-1.65",
      "react-utils": "static-2.4737",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize": "static-1.3725",
      "sanitize-text": "static-1.7500",
      "signup-constants": "static-1.17568",
      "styled-components": "static-2.64",
      "StyleGuideUI": "static-3.476",
      "usage-tracker": "static-1.6779",
      "usage-tracker-core": "static-1.6629",
      "usage-tracker-multi": "static-1.5193",
      "usage-tracker-public": "static-1.6590",
      "visitor-ui-component-library-icons": "static-1.5320",
      "hs-promise-rejection-tracking": "static-1.4750",
      "raven-hubspot": "static-1.5536",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.2882",
      "moment": "static-3.26",
      "quartz-core": "static-1.5381",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4208",
      "foundations-components": "static-1.6855",
      "foundations-theming": "static-1.3692",
      "UIComponents": "static-3.7810",
      "cv-backend-services": "static-1.1336",
      "immutable-less": "static-1.3907",
      "conversations-skeleton-state": "static-1.6711",
      "crm-events-viz-core": "static-1.31239",
      "icons": "static-2.596",
      "react-input-autosize": "static-2.17",
      "tanstack-virtual": "static-1.15",
      "rpc-client-utils": "static-1.4046",
      "ui-images": "static-2.966",
      "permission-components": "static-1.4691",
      "react-virtualized": "static-2.82",
      "HeadJS": "static-2.623",
      "framer-motion": "static-1.53",
      "hs-test-utils-bend-plugin": "static-1.2454",
      "msw": "static-1.39",
      "testing-library": "static-1.135",
      "i18n-data": "static-1.208",
      "moment-timezone": "static-5.68",
      "jasmine": "static-4.3660",
      "quartz-core-utils": "static-1.3029",
      "signup-ui-url-generator": "static-2.7425",
      "HubStyle": "static-2.11171",
      "sassPrefix": "static-1.142",
      "csstype": "static-1.50",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.5196",
      "dispatcher": "static-1.122",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.699",
      "hub-http-shared-msw-handlers": "static-1.8457",
      "hubspotter-http": "static-1.3998",
      "hubspotter-http-shared-msw-handlers": "static-1.8455",
      "mobile-manifest-mixins": "static-1.395",
      "platform-navigation-bootstrap": "static-1.11854",
      "quick-fetch": "static-1.2772",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.334",
      "hs-story-utils": "static-1.8713",
      "bend-plugin-foundations-components": "static-1.3124",
      "floating-ui": "static-1.41",
      "foundations-theming-specialty": "static-1.1408",
      "tanstack-table": "static-1.23",
      "bend-plugin-foundations-theming": "static-1.2175",
      "foundations-theming-base": "static-1.2677",
      "ts-schema": "static-1.3526",
      "apollo-stack-hubspot": "static-3.69",
      "avatar-components": "static-1.1827",
      "content-assistance-lib": "static-1.6980",
      "crm-component-utils": "static-1.37411",
      "crm-display-components": "static-1.23161",
      "crm-fe-perf": "static-1.22315",
      "crm-links": "static-1.5537",
      "crm-message-bus": "static-1.41232",
      "crm-search-service-types": "static-1.622",
      "crm-source-interpretation-lib": "static-1.4637",
      "customer-data-communicator": "static-1.43781",
      "customer-data-email": "static-1.16929",
      "customer-data-filters-ui": "static-1.37435",
      "customer-data-objects": "static-1.6988",
      "customer-data-objects-ui-components": "static-1.12322",
      "customer-data-properties": "static-1.49507",
      "customer-data-rte": "static-1.31527",
      "customer-data-ui-utilities": "static-1.9118",
      "data-fetching-client": "static-1.9014",
      "draft-plugins": "static-2.20522",
      "file-manager-components": "static-1.21778",
      "FileManagerCore": "static-1.37277",
      "frontend-preferences-client": "static-1.7286",
      "hubspot-apollo-client": "static-1.4172",
      "hubspot-prosemirror": "static-1.16491",
      "object-comments-thread-lib": "static-1.9039",
      "reference-resolvers-lite": "static-1.7398",
      "ui-addon-upgrades": "static-9.16974",
      "universal-associations-select": "static-1.10276",
      "platform-infra-nav-components": "static-1.7108",
      "graphql": "static-1.67",
      "ai-components-ui-library": "static-1.7304",
      "superstore": "static-1.4069",
      "ui-addon-video-player": "static-1.8103",
      "ui-coaching-tips": "static-1.26726",
      "card-properties-lib": "static-1.42378",
      "crm-actions": "static-1.5549",
      "crm-cards-data": "static-1.339",
      "crm-cards-sdk": "static-1.41677",
      "customer-data-properties-shared-msw-handlers": "static-1.7784",
      "customer-data-property-utils": "static-1.7315",
      "customer-data-tracking": "static-1.6195",
      "framework-data-schema-resolvers": "static-1.6241",
      "usage-tracker-container": "static-1.6769",
      "framework-data-table": "static-2.10515",
      "location-customization-utils-lib": "static-1.7301",
      "calling-error-reporting": "static-1.30639",
      "calling-internal-common": "static-1.30633",
      "calling-usage-tracker": "static-1.5843",
      "crm_data": "static-4.89968",
      "crm_schema": "static-3.90007",
      "crm-legacy-global-containers": "static-1.23140",
      "customer-data-content": "static-1.26082",
      "draft-content-plugins": "static-1.26876",
      "draft-convert": "static-2.31",
      "draft-email-branding-plugin": "static-2.22865",
      "draft-extend": "static-2.46",
      "draft-js": "static-5.37",
      "draft-signature-plugin": "static-1.22563",
      "EmailSignatureEditor": "static-1.23099",
      "FileManagerLib": "static-1.37418",
      "hubspot-prosemirror-plugins": "static-1.16483",
      "integration-settings-components": "static-1.13464",
      "integrations-lib": "static-1.14193",
      "integrations-tracking-lib": "static-1.4993",
      "native-integrations-shared-strings": "static-1.7155",
      "nav-meta": "static-1.27820",
      "outreach-assistant-email-generation": "static-1.5008",
      "property-translator": "static-1.4721",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.35862",
      "react-colorpicker": "static-2.9609",
      "react-dnd-compat": "static-1.4022",
      "react-immutable-render-mixin": "static-1.9",
      "reference-resolvers": "static-1.7520",
      "rich-text-lib": "static-1.18689",
      "sales-email-signature-service-client": "static-1.3275",
      "sequences-lib": "static-1.7100",
      "timezone-utils": "static-2.4548",
      "ui-addon-i18n": "static-1.10336",
      "ui-addon-iframeable": "static-1.8267",
      "ui-business-units-lib": "static-1.8272",
      "ui-gdpr-components": "static-1.9579",
      "ui-shepherd-react": "static-3.9421",
      "user-context": "static-1.4539",
      "whatsapp-sending-lib": "static-1.3694",
      "apollo-dlb": "static-3.73",
      "apollo-link-hub-http": "static-2.4078",
      "salesImages": "static-1.511",
      "customer-data-filters-ui-msw-helpers": "static-1.19869",
      "customer-data-reference-ui-components": "static-1.12416",
      "FormUrlGenerator": "static-2.4054",
      "framework-builder-read-service-client": "static-1.3474",
      "framework-data-schema-quick-fetch": "static-1.6146",
      "inbound-db-meta-service-client": "static-1.3133",
      "inbound-db-properties-service-client": "static-1.3354",
      "lodash": "static-4.7",
      "multi-account-reference-resolvers": "static-1.360",
      "onboarding-tours": "static-1.15702",
      "SharedI18nStrings": "static-1.171",
      "ui-addon-teams": "static-1.20699",
      "calling-cross-tab-library": "static-1.18635",
      "calling-global-api": "static-1.62305",
      "calling-integration-cross-tab": "static-1.21395",
      "calling-lifecycle-internal": "static-1.63687",
      "calling-lifecycle-messages": "static-1.55981",
      "conditional-properties-service-client": "static-1.3314",
      "external-options-client-types": "static-1.3522",
      "google-libphonenumber": "static-1.21",
      "inbounddb-objects-service-types": "static-1.3625",
      "object-builder-ui-client": "static-1.46655",
      "pipeline-validation-client-types": "static-1.3319",
      "smart-property-lib": "static-1.4428",
      "tiered-pricing": "static-1.241",
      "ui-addon-form-validation": "static-1.10372",
      "directed-graph": "static-1.284",
      "event-emitter": "static-1.348",
      "fast-json-stable-stringify": "static-1.4",
      "immerable": "static-1.3462",
      "video-components-external": "static-1.9424",
      "video-data-lib": "static-1.33082",
      "audio-components": "static-1.5120",
      "cropperjs": "static-1.10",
      "FileManagerImages": "static-1.34929",
      "video-components": "static-1.11427",
      "video-embed": "static-1.33916",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.23559",
      "knowledge-content-types": "static-1.8036",
      "payment-link-components": "static-1.21901",
      "ui-addon-emoji-picker": "static-1.9283",
      "call-summary": "static-1.36996",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.8603",
      "batch-promise": "static-1.947",
      "feature-store-service-types": "static-1.3999",
      "growth-monetization-service-types": "static-1.4006",
      "merchandise-lib": "static-1.233",
      "self-service-api": "static-1.9598",
      "upgrade-management-service-types": "static-1.3990",
      "chatspot-client-types": "static-1.10032",
      "chatspot-core": "static-1.18906",
      "ContentUtils": "static-1.66349",
      "copilot-toolkit": "static-1.9438",
      "growth-onboarding-feedback-components": "static-1.5849",
      "customer-data-sidebar": "static-2.44303",
      "enrichment-properties-lib": "static-1.13546",
      "persist-promise": "static-1.3105",
      "crm-pipelines-api-client-types": "static-1.3499",
      "customer-data-associations": "static-1.6576",
      "reporting-data": "static-1.64947",
      "ui-addon-draggable": "static-3.4208",
      "crm-record-cards-service-types": "static-1.3091",
      "crm_universal": "static-1.21155",
      "SalesContentIndexUI": "static-3.8155",
      "signup-ui-lego-core": "static-1.19578",
      "content-embed-lib": "static-1.6687",
      "data-model-builder-lib": "static-1.10232",
      "remote-ui": "static-1.52",
      "ui-components-test-utils": "static-1.5001",
      "ui-extensions-remote-renderer": "static-1.15427",
      "universal-page-editor-lib": "static-1.2394",
      "integrations-error-boundary-lib": "static-1.11608",
      "laboratory-lib": "static-3.6539",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.9817",
      "rxjs": "static-5.10",
      "ui-universal-auth": "static-1.8206",
      "messaging-types-lib": "static-1.44022",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "data-token-picker": "static-1.15322",
      "sequences-client-types-lib": "static-1.6957",
      "foundations-components-test-utils": "static-1.4339",
      "magpie-lib": "static-1.5002",
      "navigation-messaging": "static-1.5510",
      "getting-started-shared-tasks": "static-1.16714",
      "getting-started-shared-tasks-store": "static-1.15832",
      "whatsapp-management-lib": "static-1.6853",
      "growth-data-modal": "static-1.4658",
      "growth-onboarding-confetti": "static-1.2427",
      "growth-onboarding-next-action-utils": "static-1.749",
      "navigation-components": "static-1.16183",
      "ui-shepherd-tracker": "static-1.6802",
      "shared-worker-versioning": "static-1.10418",
      "worker-connection-library": "static-1.15863",
      "calling-orchestration-shared-library": "static-1.33536",
      "onboarding-scopes": "static-1.5868",
      "breeze-intelligence-kit": "static-1.4693",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.8540",
      "fsm": "static-1.3045",
      "policy-lib": "static-1.6111",
      "react-tinymce": "static-1.53469",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.52595",
      "tinymce-plugins": "static-1.55709",
      "tinymce-themes": "static-1.54565",
      "commerce-products-lib": "static-1.7630",
      "content-media-composition-data-lib": "static-1.9626",
      "content-media-compositions": "static-2.13633",
      "idb-keyval": "static-1.29",
      "magpie-types": "static-1.4462",
      "media-bridge-lib": "static-1.17922",
      "content-icons-ui": "static-1.2015",
      "social-insights-client-types": "static-1.20289",
      "outpost": "static-1.3675",
      "commerce-analytics-service-client": "static-1.3009",
      "ui-addon-opt": "static-4.7851",
      "commerce-tours-lib": "static-1.5065",
      "growth-onboarding-reliability": "static-1.4475",
      "sales-checkout-service-client": "static-1.3021",
      "ai-addon-copilot-preview": "static-1.6516",
      "wootric-nps": "static-1.6171",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4105",
      "underscore": "static-1.8",
      "simple-logging-lib": "static-1.2344",
      "card-payment-highlight-lib": "static-1.35438",
      "card-subscription-highlight-lib": "static-1.37746",
      "commerce-billing-lib": "static-1.17401",
      "commerce-contract-lib": "static-1.9922",
      "crm_components": "static-3.89968",
      "invoices-highlight-card-lib": "static-1.52753",
      "orders-highlight-card-lib": "static-1.19966",
      "products-highlight-card-lib": "static-1.15915",
      "project-storage": "static-1.4041",
      "quotes-highlight-card-lib": "static-1.69777",
      "usage-based-billing-components-lib": "static-1.7009",
      "reporting-client-types": "static-1.2251",
      "react-flip-move": "static-1.55",
      "FireAlarmUi": "static-1.4022",
      "sales-templates-service-types-lib": "static-1.3584",
      "ui-asset-management-lib": "static-1.10063",
      "emoji-regex": "static-1.7",
      "association-settings-lib": "static-1.8525",
      "collaboration-sidebar": "static-1.56140",
      "data-model-commons-lib": "static-1.10856",
      "feedback-loader": "static-1.28012",
      "final-form": "static-1.53",
      "html-to-image": "static-1.38",
      "object-definition-builder-lib": "static-1.6325",
      "property-management-iframe": "static-1.10903",
      "reactflow": "static-1.45",
      "used-in-list-lib": "static-1.6180",
      "visual-association": "static-1.5136",
      "highcharts": "static-8.89",
      "reporting-visualizations": "static-1.57024",
      "ui-extensibility-client-types": "static-1.3395",
      "automation-platform-service-types": "static-1.2319",
      "ContentData": "static-1.66424",
      "email-portal-health-service-types": "static-1.373",
      "marketing-email-service-types": "static-1.1620",
      "reactive-lib": "static-1.93",
      "short-messages-app-service-client": "static-1.3388",
      "ui-tool-access": "static-1.9426",
      "calling-orchestration-schema": "static-1.33761",
      "trellis-story-utils": "static-1.3896",
      "storybook-react": "static-1.16",
      "hub-http-contrib": "static-1.2450",
      "interframe": "static-3.4113",
      "tinymce-data": "static-1.38680",
      "ui-addon-sales-email": "static-1.4550",
      "codemirror": "static-5.80",
      "layout-dnd-components": "static-1.11351",
      "layout-dnd-utils": "static-1.10326",
      "react-codemirror": "static-1.9955",
      "ui-brand-identity-lib": "static-1.12229",
      "NamespacedHubStyle": "static-2.8606",
      "products-iframe-lib": "static-1.6247",
      "products-ui-components-shared-msw-handlers": "static-1.8839",
      "hls.js": "static-1.24",
      "js-cookie": "static-1.18",
      "onboarding-tours-client": "static-1.3916",
      "ai-rendering-library": "static-1.8105",
      "ai-settings-ui-library": "static-1.6723",
      "chirp-fetch": "static-1.1342",
      "copilot-plugins": "static-1.9411",
      "commerce-shared-components-lib": "static-1.16865",
      "commerce-subscription-lib": "static-1.35323",
      "commerce-tools-ui-lib": "static-1.8897",
      "usage-tracker-session-replay": "static-1.4465",
      "utility-belt": "static-1.1847",
      "payments-enrollment-embed-lib": "static-1.20636",
      "quotes-ui-lib": "static-1.78493",
      "zustand": "static-1.51",
      "accounting-integrations-ui-components": "static-1.5993",
      "invoices-ui-lib": "static-1.52769",
      "commerce-products-api": "static-1.1286",
      "SafeStorage": "static-1.3730",
      "invoices-iframe-lib": "static-1.54827",
      "quotes-modal-lib": "static-1.100450",
      "reporting-ui-components": "static-2.62221",
      "subscription-experience-data-types": "static-1.13845",
      "association-translator": "static-1.2507",
      "crm-settings-header-lib": "static-1.7549",
      "settings-ui-nav": "static-2.9491",
      "chatspot-widget-iframe": "static-1.18898",
      "collaboration-sidebar-common": "static-1.936",
      "property-management-common": "static-1.3190",
      "d3": "static-1.7",
      "crm-object-map": "static-1.4291",
      "advanced-menus-core": "static-1.14189",
      "advanced-menus-lib": "static-1.11256",
      "ExportDialog": "static-6.9816",
      "ui-memberships-settings-lib": "static-1.32144",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.8651",
      "browser-eslint": "static-2.57",
      "multi-currency-client-types": "static-1.3135",
      "sales-views-client-types": "static-1.3607",
      "highlight.js": "static-1.45",
      "reporting-action-components": "static-1.39588",
      "ui-addon-react-router-dom": "static-1.8952",
      "growth-onboarding-empty-states": "static-1.4858",
      "InboxConnectUtils": "static-4.13193",
      "payments-post-enroll-local-storage-lib": "static-1.4422",
      "qrcode-generator": "static-1.52",
      "trials-service-types": "static-1.3407",
      "amplitude-session-replay-browser": "static-1.45",
      "marketplace-ui-apps-core": "static-1.16338",
      "stripe-embedded-components": "static-1.6488",
      "products-ui-components": "static-1.38150",
      "totals-ui-components": "static-1.21914",
      "reporting-plugins": "static-1.9287",
      "reporting-reports": "static-1.64627",
      "reporting-snowflake": "static-1.53567",
      "crm-index-visualization-object-layout": "static-1.3934",
      "crm-object-search-query-utilities": "static-1.8244",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.14188",
      "simple-menus-lib": "static-1.15705",
      "dashboard-lib": "static-1.79134",
      "share-with-third-party-component-lib": "static-1.8053",
      "developer-experience-shared-components": "static-1.9698",
      "marketplace-ui-client-types": "static-1.15211",
      "marketplace-ui-common": "static-1.17804",
      "ui-addon-integrations-directory-panel": "static-2.7400",
      "stripe-connect-js": "static-1.43",
      "property-description-translator": "static-1.3173",
      "commerce-totals-service-types": "static-1.3262",
      "campaign-roi-lib": "static-1.7065",
      "reporting-datasets-permissions-lib": "static-1.11719",
      "redux-actions": "static-3.7",
      "apps-service-types": "static-1.3341",
      "oauth-service-types": "static-1.3593",
      "react-window": "static-1.13"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.27028",
      "ably": "/ably/static-2.2",
      "conversations-async-data": "/conversations-async-data/static-2.6997",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8267",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15352",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.11995",
      "conversations-message-history": "/conversations-message-history/static-1.10619",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.9807",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.20391",
      "head-dlb": "/head-dlb/static-1.4360",
      "hs-promise-utils": "/hs-promise-utils/static-1.4872",
      "hs-test-utils": "/hs-test-utils/static-1.7343",
      "hubspot-dlb": "/hubspot-dlb/static-2.1707",
      "HubStyleTokens": "/HubStyleTokens/static-2.10863",
      "I18n": "/I18n/static-7.1452",
      "jasmine-immutable": "/jasmine-immutable/static-1.2313",
      "jasmine-runner": "/jasmine-runner/static-1.5770",
      "quartz": "/quartz/static-1.6162",
      "react-dlb": "/react-dlb/static-1.62",
      "react-transition-group": "/react-transition-group/static-2.8",
      "redux-thunk": "/redux-thunk/static-2.43",
      "transmute": "/transmute/static-2.77",
      "urlinator": "/urlinator/static-1.3887",
      "viral-links-lib": "/viral-links-lib/static-1.6257",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5509",
      "webpack-env": "/webpack-env/static-1.54",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.3914",
      "atom": "/atom/static-1.4498",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4141",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.8290",
      "conversations-prop-types": "/conversations-prop-types/static-1.6780",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.5118",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.19128",
      "cssUtils": "/cssUtils/static-1.602",
      "enviro": "/enviro/static-4.328",
      "flux-actions": "/flux-actions/static-1.287",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.5499",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3531",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.9058",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.306",
      "raven": "/raven/static-3.5229",
      "react": "/react/static-7.151",
      "react-aria": "/react-aria/static-1.44",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "react-rhumb": "/react-rhumb/static-1.15950",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-utils": "/react-utils/static-2.4737",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize": "/sanitize/static-1.3725",
      "sanitize-text": "/sanitize-text/static-1.7500",
      "signup-constants": "/signup-constants/static-1.17568",
      "styled-components": "/styled-components/static-2.64",
      "StyleGuideUI": "/StyleGuideUI/static-3.476",
      "usage-tracker": "/usage-tracker/static-1.6779",
      "usage-tracker-core": "/usage-tracker-core/static-1.6629",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5193",
      "usage-tracker-public": "/usage-tracker-public/static-1.6590",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5320",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4750",
      "raven-hubspot": "/raven-hubspot/static-1.5536",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2882",
      "moment": "/moment/static-3.26",
      "quartz-core": "/quartz-core/static-1.5381",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4208",
      "foundations-components": "/foundations-components/static-1.6855",
      "foundations-theming": "/foundations-theming/static-1.3692",
      "UIComponents": "/UIComponents/static-3.7810",
      "cv-backend-services": "/cv-backend-services/static-1.1336",
      "immutable-less": "/immutable-less/static-1.3907",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6711",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.31239",
      "icons": "/icons/static-2.596",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "tanstack-virtual": "/tanstack-virtual/static-1.15",
      "rpc-client-utils": "/rpc-client-utils/static-1.4046",
      "ui-images": "/ui-images/static-2.966",
      "permission-components": "/permission-components/static-1.4691",
      "react-virtualized": "/react-virtualized/static-2.82",
      "HeadJS": "/HeadJS/static-2.623",
      "framer-motion": "/framer-motion/static-1.53",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2454",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.135",
      "i18n-data": "/i18n-data/static-1.208",
      "moment-timezone": "/moment-timezone/static-5.68",
      "jasmine": "/jasmine/static-4.3660",
      "quartz-core-utils": "/quartz-core-utils/static-1.3029",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7425",
      "HubStyle": "/HubStyle/static-2.11171",
      "sassPrefix": "/sassPrefix/static-1.142",
      "csstype": "/csstype/static-1.50",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5196",
      "dispatcher": "/dispatcher/static-1.122",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.699",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8457",
      "hubspotter-http": "/hubspotter-http/static-1.3998",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8455",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.395",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11854",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.334",
      "hs-story-utils": "/hs-story-utils/static-1.8713",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3124",
      "floating-ui": "/floating-ui/static-1.41",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1408",
      "tanstack-table": "/tanstack-table/static-1.23",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2175",
      "foundations-theming-base": "/foundations-theming-base/static-1.2677",
      "ts-schema": "/ts-schema/static-1.3526",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.69",
      "avatar-components": "/avatar-components/static-1.1827",
      "content-assistance-lib": "/content-assistance-lib/static-1.6980",
      "crm-component-utils": "/crm-component-utils/static-1.37411",
      "crm-display-components": "/crm-display-components/static-1.23161",
      "crm-fe-perf": "/crm-fe-perf/static-1.22315",
      "crm-links": "/crm-links/static-1.5537",
      "crm-message-bus": "/crm-message-bus/static-1.41232",
      "crm-search-service-types": "/crm-search-service-types/static-1.622",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.4637",
      "customer-data-communicator": "/customer-data-communicator/static-1.43781",
      "customer-data-email": "/customer-data-email/static-1.16929",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.37435",
      "customer-data-objects": "/customer-data-objects/static-1.6988",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12322",
      "customer-data-properties": "/customer-data-properties/static-1.49507",
      "customer-data-rte": "/customer-data-rte/static-1.31527",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9118",
      "data-fetching-client": "/data-fetching-client/static-1.9014",
      "draft-plugins": "/draft-plugins/static-2.20522",
      "file-manager-components": "/file-manager-components/static-1.21778",
      "FileManagerCore": "/FileManagerCore/static-1.37277",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7286",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4172",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.16491",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.9039",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7398",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.16974",
      "universal-associations-select": "/universal-associations-select/static-1.10276",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7108",
      "graphql": "/graphql/static-1.67",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.7304",
      "superstore": "/superstore/static-1.4069",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8103",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.26726",
      "card-properties-lib": "/card-properties-lib/static-1.42378",
      "crm-actions": "/crm-actions/static-1.5549",
      "crm-cards-data": "/crm-cards-data/static-1.339",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.41677",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.7784",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7315",
      "customer-data-tracking": "/customer-data-tracking/static-1.6195",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6241",
      "usage-tracker-container": "/usage-tracker-container/static-1.6769",
      "framework-data-table": "/framework-data-table/static-2.10515",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.7301",
      "calling-error-reporting": "/calling-error-reporting/static-1.30639",
      "calling-internal-common": "/calling-internal-common/static-1.30633",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.5843",
      "crm_data": "/crm_data/static-4.89968",
      "crm_schema": "/crm_schema/static-3.90007",
      "crm-legacy-global-containers": "/crm-legacy-global-containers/static-1.23140",
      "customer-data-content": "/customer-data-content/static-1.26082",
      "draft-content-plugins": "/draft-content-plugins/static-1.26876",
      "draft-convert": "/draft-convert/static-2.31",
      "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.22865",
      "draft-extend": "/draft-extend/static-2.46",
      "draft-js": "/draft-js/static-5.37",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.22563",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23099",
      "FileManagerLib": "/FileManagerLib/static-1.37418",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.16483",
      "integration-settings-components": "/integration-settings-components/static-1.13464",
      "integrations-lib": "/integrations-lib/static-1.14193",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.4993",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7155",
      "nav-meta": "/nav-meta/static-1.27820",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.5008",
      "property-translator": "/property-translator/static-1.4721",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.35862",
      "react-colorpicker": "/react-colorpicker/static-2.9609",
      "react-dnd-compat": "/react-dnd-compat/static-1.4022",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "reference-resolvers": "/reference-resolvers/static-1.7520",
      "rich-text-lib": "/rich-text-lib/static-1.18689",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3275",
      "sequences-lib": "/sequences-lib/static-1.7100",
      "timezone-utils": "/timezone-utils/static-2.4548",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10336",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8267",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8272",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.9579",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9421",
      "user-context": "/user-context/static-1.4539",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.3694",
      "apollo-dlb": "/apollo-dlb/static-3.73",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4078",
      "salesImages": "/salesImages/static-1.511",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.19869",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12416",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4054",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3474",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6146",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3133",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3354",
      "lodash": "/lodash/static-4.7",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.360",
      "onboarding-tours": "/onboarding-tours/static-1.15702",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.171",
      "ui-addon-teams": "/ui-addon-teams/static-1.20699",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.18635",
      "calling-global-api": "/calling-global-api/static-1.62305",
      "calling-integration-cross-tab": "/calling-integration-cross-tab/static-1.21395",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.63687",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.55981",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3314",
      "external-options-client-types": "/external-options-client-types/static-1.3522",
      "google-libphonenumber": "/google-libphonenumber/static-1.21",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3625",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.46655",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3319",
      "smart-property-lib": "/smart-property-lib/static-1.4428",
      "tiered-pricing": "/tiered-pricing/static-1.241",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10372",
      "directed-graph": "/directed-graph/static-1.284",
      "event-emitter": "/event-emitter/static-1.348",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "immerable": "/immerable/static-1.3462",
      "video-components-external": "/video-components-external/static-1.9424",
      "video-data-lib": "/video-data-lib/static-1.33082",
      "audio-components": "/audio-components/static-1.5120",
      "cropperjs": "/cropperjs/static-1.10",
      "FileManagerImages": "/FileManagerImages/static-1.34929",
      "video-components": "/video-components/static-1.11427",
      "video-embed": "/video-embed/static-1.33916",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.23559",
      "knowledge-content-types": "/knowledge-content-types/static-1.8036",
      "payment-link-components": "/payment-link-components/static-1.21901",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9283",
      "call-summary": "/call-summary/static-1.36996",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.8603",
      "batch-promise": "/batch-promise/static-1.947",
      "feature-store-service-types": "/feature-store-service-types/static-1.3999",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4006",
      "merchandise-lib": "/merchandise-lib/static-1.233",
      "self-service-api": "/self-service-api/static-1.9598",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.3990",
      "chatspot-client-types": "/chatspot-client-types/static-1.10032",
      "chatspot-core": "/chatspot-core/static-1.18906",
      "ContentUtils": "/ContentUtils/static-1.66349",
      "copilot-toolkit": "/copilot-toolkit/static-1.9438",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.5849",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.44303",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.13546",
      "persist-promise": "/persist-promise/static-1.3105",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3499",
      "customer-data-associations": "/customer-data-associations/static-1.6576",
      "reporting-data": "/reporting-data/static-1.64947",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4208",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3091",
      "crm_universal": "/crm_universal/static-1.21155",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8155",
      "signup-ui-lego-core": "/signup-ui-lego-core/static-1.19578",
      "content-embed-lib": "/content-embed-lib/static-1.6687",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.10232",
      "remote-ui": "/remote-ui/static-1.52",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5001",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.15427",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2394",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.11608",
      "laboratory-lib": "/laboratory-lib/static-3.6539",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.9817",
      "rxjs": "/rxjs/static-5.10",
      "ui-universal-auth": "/ui-universal-auth/static-1.8206",
      "messaging-types-lib": "/messaging-types-lib/static-1.44022",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "data-token-picker": "/data-token-picker/static-1.15322",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.6957",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4339",
      "magpie-lib": "/magpie-lib/static-1.5002",
      "navigation-messaging": "/navigation-messaging/static-1.5510",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.16714",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.15832",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.6853",
      "growth-data-modal": "/growth-data-modal/static-1.4658",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2427",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.749",
      "navigation-components": "/navigation-components/static-1.16183",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.6802",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10418",
      "worker-connection-library": "/worker-connection-library/static-1.15863",
      "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.33536",
      "onboarding-scopes": "/onboarding-scopes/static-1.5868",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.4693",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.8540",
      "fsm": "/fsm/static-1.3045",
      "policy-lib": "/policy-lib/static-1.6111",
      "react-tinymce": "/react-tinymce/static-1.53469",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.52595",
      "tinymce-plugins": "/tinymce-plugins/static-1.55709",
      "tinymce-themes": "/tinymce-themes/static-1.54565",
      "commerce-products-lib": "/commerce-products-lib/static-1.7630",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.9626",
      "content-media-compositions": "/content-media-compositions/static-2.13633",
      "idb-keyval": "/idb-keyval/static-1.29",
      "magpie-types": "/magpie-types/static-1.4462",
      "media-bridge-lib": "/media-bridge-lib/static-1.17922",
      "content-icons-ui": "/content-icons-ui/static-1.2015",
      "social-insights-client-types": "/social-insights-client-types/static-1.20289",
      "outpost": "/outpost/static-1.3675",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3009",
      "ui-addon-opt": "/ui-addon-opt/static-4.7851",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5065",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4475",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3021",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.6516",
      "wootric-nps": "/wootric-nps/static-1.6171",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4105",
      "underscore": "/underscore/static-1.8",
      "simple-logging-lib": "/simple-logging-lib/static-1.2344",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.35438",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.37746",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.17401",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.9922",
      "crm_components": "/crm_components/static-3.89968",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.52753",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.19966",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.15915",
      "project-storage": "/project-storage/static-1.4041",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.69777",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7009",
      "reporting-client-types": "/reporting-client-types/static-1.2251",
      "react-flip-move": "/react-flip-move/static-1.55",
      "FireAlarmUi": "/FireAlarmUi/static-1.4022",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3584",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10063",
      "emoji-regex": "/emoji-regex/static-1.7",
      "association-settings-lib": "/association-settings-lib/static-1.8525",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.56140",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.10856",
      "feedback-loader": "/feedback-loader/static-1.28012",
      "final-form": "/final-form/static-1.53",
      "html-to-image": "/html-to-image/static-1.38",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.6325",
      "property-management-iframe": "/property-management-iframe/static-1.10903",
      "reactflow": "/reactflow/static-1.45",
      "used-in-list-lib": "/used-in-list-lib/static-1.6180",
      "visual-association": "/visual-association/static-1.5136",
      "highcharts": "/highcharts/static-8.89",
      "reporting-visualizations": "/reporting-visualizations/static-1.57024",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3395",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2319",
      "ContentData": "/ContentData/static-1.66424",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.373",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1620",
      "reactive-lib": "/reactive-lib/static-1.93",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3388",
      "ui-tool-access": "/ui-tool-access/static-1.9426",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.33761",
      "trellis-story-utils": "/trellis-story-utils/static-1.3896",
      "storybook-react": "/storybook-react/static-1.16",
      "hub-http-contrib": "/hub-http-contrib/static-1.2450",
      "interframe": "/interframe/static-3.4113",
      "tinymce-data": "/tinymce-data/static-1.38680",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4550",
      "codemirror": "/codemirror/static-5.80",
      "layout-dnd-components": "/layout-dnd-components/static-1.11351",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.10326",
      "react-codemirror": "/react-codemirror/static-1.9955",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.12229",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8606",
      "products-iframe-lib": "/products-iframe-lib/static-1.6247",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.8839",
      "hls.js": "/hls.js/static-1.24",
      "js-cookie": "/js-cookie/static-1.18",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.3916",
      "ai-rendering-library": "/ai-rendering-library/static-1.8105",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.6723",
      "chirp-fetch": "/chirp-fetch/static-1.1342",
      "copilot-plugins": "/copilot-plugins/static-1.9411",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.16865",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.35323",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.8897",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4465",
      "utility-belt": "/utility-belt/static-1.1847",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.20636",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.78493",
      "zustand": "/zustand/static-1.51",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.5993",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.52769",
      "commerce-products-api": "/commerce-products-api/static-1.1286",
      "SafeStorage": "/SafeStorage/static-1.3730",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.54827",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.100450",
      "reporting-ui-components": "/reporting-ui-components/static-2.62221",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.13845",
      "association-translator": "/association-translator/static-1.2507",
      "crm-settings-header-lib": "/crm-settings-header-lib/static-1.7549",
      "settings-ui-nav": "/settings-ui-nav/static-2.9491",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.18898",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.936",
      "property-management-common": "/property-management-common/static-1.3190",
      "d3": "/d3/static-1.7",
      "crm-object-map": "/crm-object-map/static-1.4291",
      "advanced-menus-core": "/advanced-menus-core/static-1.14189",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11256",
      "ExportDialog": "/ExportDialog/static-6.9816",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.32144",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.8651",
      "browser-eslint": "/browser-eslint/static-2.57",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3135",
      "sales-views-client-types": "/sales-views-client-types/static-1.3607",
      "highlight.js": "/highlight.js/static-1.45",
      "reporting-action-components": "/reporting-action-components/static-1.39588",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8952",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.4858",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.13193",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4422",
      "qrcode-generator": "/qrcode-generator/static-1.52",
      "trials-service-types": "/trials-service-types/static-1.3407",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.45",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.16338",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.6488",
      "products-ui-components": "/products-ui-components/static-1.38150",
      "totals-ui-components": "/totals-ui-components/static-1.21914",
      "reporting-plugins": "/reporting-plugins/static-1.9287",
      "reporting-reports": "/reporting-reports/static-1.64627",
      "reporting-snowflake": "/reporting-snowflake/static-1.53567",
      "crm-index-visualization-object-layout": "/crm-index-visualization-object-layout/static-1.3934",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.8244",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.14188",
      "simple-menus-lib": "/simple-menus-lib/static-1.15705",
      "dashboard-lib": "/dashboard-lib/static-1.79134",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8053",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.9698",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.15211",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.17804",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7400",
      "stripe-connect-js": "/stripe-connect-js/static-1.43",
      "property-description-translator": "/property-description-translator/static-1.3173",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3262",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.7065",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.11719",
      "redux-actions": "/redux-actions/static-3.7",
      "apps-service-types": "/apps-service-types/static-1.3341",
      "oauth-service-types": "/oauth-service-types/static-1.3593",
      "react-window": "/react-window/static-1.13"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};